import { Currency } from '@interticket/core';
import { ICartItemViewModel } from '@core/interfaces/cart/cart-item-view-model.interface';
import { EventView } from '../event/event-view.model';
import { CartItem } from './cart-item.model';

export class CartItemViewModel extends CartItem implements ICartItemViewModel {

  readonly event: EventView;
  readonly name: string;
  readonly currency: Currency;

  constructor(iCartItemViewModel: ICartItemViewModel) {
    super(iCartItemViewModel);
    this.event = new EventView(iCartItemViewModel.event);
    this.name = iCartItemViewModel.name;
    this.currency = iCartItemViewModel.currency;
  }

}
